<template>
    <div>
      <div class="table-toolbar d-flex justify-content-between align-items-center mb-3">
        <div class="toolbar-left">
          <button
            class="btn btn-success btn-sm mr-2"
            @click="$root.$emit('toggle_modal', 'add_blacklist')"
          >
            Tambah Nomor
          </button>
          <button
            class="btn btn-primary btn-sm mr-2"
            @click="$root.$emit('toggle_modal', 'add_blacklist_keyword')"
          >
            Keyword Blacklist
          </button>
        </div>
      </div>
      
      <vue-good-table
        mode="remote"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        :totalRows="table.total_records"
        :isLoading.sync="table.isLoading"
        :pagination-options="{
          enabled: true,
          dropdownAllowAll: false,
          perPageDropdown: [10, 25, 50, 100],
        }"
        :columns="table.columns"
        :rows="table.rows"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'action'">
            <a
              v-on:click="deleteBlacklist(props.row.id)"
              class="btn btn-danger text-white margin5"
            >
              Hapus
            </a>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>
  </template>
  
  <script>

  export default {
    props: ['id'],
    data() {
      return {
        table: {
          total_records: 0,
          isLoading: true,
          columns: [
            {
              label: "Nomor",
              field: "number",
              filterOptions: {
                enabled: true,
                filterTrigger: 'auto',
                placeholder: 'Cari nomor...',
              },
              sortable: false,
              width: "40%",
            },
            {
              label: "Tanggal Ditambahkan",
              field: "created_at",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              width: "40%",
            },
            {
              label: "Action",
              field: "action",
              sortable: false,
              width: "20%",
            },
          ],
          rows: [],
          serverParams: {
            columnFilters: {},
            sort: [
              {
                field: "",
                type: "",
              },
            ],
            page: 1,
            limit: 10,
          },
        },
      };
    },
    mounted() {
      this.fn = () => {
        this.loadItems();
      }
      this.$root.$on("refresh_table", this.fn);
      this.loadItems();
    },
    beforeDestroy() {
      this.$root.$off("refresh_table", this.fn);
    },
    methods: {
      async deleteBlacklist(blacklistId) {
        if (!confirm('Yakin ingin menghapus nomor dari blacklist?')) {
          return;
        }
        try {
          let response = await this.$store.dispatch("chatgpt_delete_blacklist", {
            id: this.id, 
            blacklist_id: blacklistId
          });
          this.loadItems();
          this.$toast.success(response.data.message);
        } catch (err) {
          this.$toast.error(err.response?.data?.message || "Server error");
        }
      },
      updateParams(newProps) {
        this.table.serverParams = Object.assign(
          {},
          this.table.serverParams,
          newProps
        );
      },
      onPageChange(params) {
        this.updateParams({page: params.currentPage});
        this.loadItems();
      },
      onPerPageChange(params) {
        this.updateParams({limit: params.currentPerPage});
        this.loadItems();
      },
      onSortChange(params) {
        this.updateParams({
          sort: [
            {
              type: params.sortType,
              field: this.table.columns[params.columnIndex].field,
            },
          ],
        });
        this.loadItems();
      },
      onColumnFilter(params) {
        this.table.serverParams.columnFilters = params.columnFilters || {};
        this.table.serverParams.page = 1;
        this.loadItems();
      },
      async loadItems() {
        this.table.isLoading = true
        try {
          let response = await this.getFromServer(this.table.serverParams);
          this.table.total_records = response.data.data.total_records;
          this.table.rows = response.data.data.blacklist.map(item => ({
            ...item,
            created_at: this.formatDate(item.created_at)
          }));
        } catch (err) {
          this.$toast.error("Too many request");
        }
        this.table.isLoading = false
      },
      async getFromServer(param) {
        return await this.$store.dispatch("chatgpt_blacklist_list", {
          id: this.id,
          ...param
        });
      },
      formatDate(timestamp) {
        if (!timestamp) return '-';
        const date = new Date(timestamp);
        return date.toLocaleString('id-ID', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
    },
  };
  </script>
  
  <style scoped>
  .margin5 {
    margin: 5px;
  }

  .table-toolbar {
    padding: 4px 0 8px;
  }

  .toolbar-left {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
  </style>

